import { render, staticRenderFns } from "./DepthChart.vue?vue&type=template&id=cc8586f0&scoped=true&"
import script from "./DepthChart.vue?vue&type=script&lang=ts&"
export * from "./DepthChart.vue?vue&type=script&lang=ts&"
import style0 from "./DepthChart.vue?vue&type=style&index=0&id=cc8586f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc8586f0",
  null
  
)

export default component.exports